export type TRefreshResult = 'ok' | 'degraded' | 'logout';
export let requestRefresh: null | (() => Promise<TRefreshResult>) = null;
export const setRequestRefresh = (fn: () => Promise<TRefreshResult>): void => {
  requestRefresh = fn;
};
